import { IQuoteRespSchema } from '@monetize/types/app';
import { useAtom } from 'jotai';
import { QuoteStateDataTypes } from '../quoteContext';
import { QuoteBannerItem } from './QuoteBannerItem';
import { bannerDismissedSelector } from './quoteBanner.utils';

export function InactiveRateInfoBanner({
  quote,
  quoteStateData,
}: {
  quote: IQuoteRespSchema;
  quoteStateData: QuoteStateDataTypes;
}) {
  const [dismissed, setDismissed] = useAtom(
    bannerDismissedSelector([quote.id, 'InactiveRateInfoBanner']),
  );

  const { isSelectedOfferingAndRateIdsInactiveForWarning: shouldShowBanner } =
    quoteStateData;
  const hasQuoteOfferings = (quote?.quoteOfferings?.length || 0) > 0;

  if (!hasQuoteOfferings || !shouldShowBanner || dismissed) {
    return null;
  }

  return (
    <QuoteBannerItem onDismiss={() => setDismissed(true)} type="warning">
      There are Rates and/or Offerings on this Quote that are no longer active.
      It is recommended to adjust to an active rate.
    </QuoteBannerItem>
  );
}
